import { role } from "api"
import types from "./types"

const getOperatorPermission = () => {
  return (dispatch) => {
    role.getOperatorPermissions()
      .then(({ data }) => {
        dispatch({
          type: types.PERMISSIONS_SET_OPERATOR,
          payload: data || {}
        })
      }).catch(console.error)
  }
}

export default {
  getOperatorPermission
}